import log from "logbeacon";
import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import { deviceDetector } from "@ospweb/sdk-ui";
import { PayChannel, PayType } from "../features/api/memberApi";
import { QUERY_KEYS } from "../config";
import { useGetListPayment } from "./useGetListPayment";

interface SubscriptionListResult {
  enabled: boolean;
}

export const useSubscriptionList = ({ enabled }: SubscriptionListResult) => {
  const { getListPayment } = useGetListPayment();
  return useQuery({
    queryKey: [QUERY_KEYS.PAYMENT_LIST_PAYMENT, "subscriptionList"],
    queryFn: () => getListPayment({ pay_type: PayType.CONTINUOUS }),
    enabled,
    select: (list: any[]) => {
      log.info("[member]-[fetchSubscriptionStatus]", list);
      const items = list
        .filter(
          (item) =>
            ["SUSPENDED", "ACTIVE"].includes(item.status) && item.pay_channel,
        )
        .map((item) => {
          const nextPaymentDate = item.next_billing_time
            ? dayjs(item.next_billing_time).format("MMM DD, YYYY")
            : "—";
          const canCancel =
            item.pay_channel === "STRIPE" ||
            (item.pay_channel === PayChannel.GOOGLE_IAP &&
              deviceDetector.isAndroidApp()) ||
            (item.pay_channel === PayChannel.APPLE_IAP &&
              deviceDetector.isIOSApp());
          return {
            pay_channel: item.pay_channel!,
            product_level: item.product_level,
            nextPaymentDate,
            canCancel,
            status: item.status!,
            id: item.id!,
            links:
              item.links?.find(
                (item: any) => item.rel === "customer_session_url",
              )?.href ?? "",
          };
        });
      return items;
    },
  });
};
